const lawyerInfo = {
  namespaced: true,
  state: {
    //律师基础信息
    lawyerBaseInfo: {},
    //律师角色信息
    lawyerRoles: [],
    //律师上下线信息
    lawyerStatus: {}
  },
  getters: {
    lawyerBaseInfo: state => state.lawyerBaseInfo || {},
    lawyerRoles: state => state.lawyerRoles || [],
    lawyerStatus: state => state.lawyerStatus || {}
  },
  mutations: {
    SET_LAWYER_BASEINFO (state, payload) {
      state.lawyerBaseInfo = payload
    },
    SET_LAWYER_ROLES (state, payload) {
      state.lawyerRoles = payload
    },
    SET_LAWYER_STATUS (state, payload) {
      state.lawyerStatus = payload
    }
  },
  actions: {
    async updatelawyerInfo (context, data) {
      // 触发mutation，存储data
      context.commit("SET_LAWYER_BASEINFO", data)
    },
    async updateLawyerStatus (context, data) {
      // 触发mutation，存储data
      context.commit("SET_LAWYER_STATUS", data)
    },
  }
}

export default lawyerInfo